import Util from '../../util/config'
import * as types from '../types'
import Vue from 'vue'

// 容器
const state = {
  fetchLoading:false,     //全局加载状态的Loading
  hardLoading:false,     //全局加载状态的Loading
};

//更改 store 中的状态的唯一方法:提交 mutation

const mutations = {

// loading开关
  [types.SET_LOADING] (state,res) {
    state.fetchLoading = res
  },
  // loading开关2：用于除了ajax请求以外的loading需求
  [types.SET_HARDLOADING] (state,res) {
    state.hardLoading = res
  },
};

let vm = new Vue({});

// action提交mutations，不直接更改状态（通过store.dispatch触发）
const actions = {

  // 购物车数量增减,true是加,false是减
  //   setLocalCount({commit},bool = true) {
  //     let count = Util.getLocal('count') || 0;
  //     if(bool) {
  //       Util.setLocal(++count,'count');
  //     }else {
  //         Util.setLocal(--count,'count');
  //     }
  //     commit(types.CHANGE_COUNT);
  //   },
};

// 如同计算属性,处理state的某个状态
const getters = {

  // selectedList(state) {
  //     // choseBool为真的商品 即打钩的商品
  //    if(state.carList!=='') {
  //      let arr = state.carList.filter((ele)=>{
  //        return ele.choseBool == true
  //      });
  //      return arr
  //    }
  // },
};




export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/detail.js